module.exports = __webpack_public_path__ + "static/img/winner2.a47316bd.png";